import { FormattedMessage } from 'react-intl';

import { FullWidthContainer } from 'atoms/layout/FullWidthContainer';
import { Vertical } from 'atoms/layout/flex';
import { HeadlineS } from 'atoms/typography';

import { Competition, Props as CompetitionProps } from './Competition';

type Props = {
  competitions: CompetitionProps['competition'][];
};

export const Competitions = ({ competitions }: Props) => {
  return (
    <FullWidthContainer>
      <Vertical gap={1.5}>
        <HeadlineS as="h2">
          <FormattedMessage
            id="Seo.Team.Competitions.competingIn"
            defaultMessage="Competing In"
          />
        </HeadlineS>
        {competitions.map(competition => (
          <Competition key={competition.slug} competition={competition} />
        ))}
      </Vertical>
    </FullWidthContainer>
  );
};
